import { MenuItem, Paper, Stack } from '@mui/material';
import { CustomButton, CustomTextField } from '../../../../common/components';
import { STATUS_OPTIONS } from '../constants/filters';

const FiltersBar = ({ filters, onFilterChange, onSearch, onReset, disabled }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: (theme) => `1px solid ${theme.palette.divider}`,
        background: (theme) => theme.palette.background.paper,
      }}
    >
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems="center">
        <CustomTextField
          label="Número de contrato"
          value={filters.contractNumber}
          onChange={(e) => onFilterChange('contractNumber', e.target.value)}
          disabled={disabled}
          size="medium"
          fullWidth
        />

        <CustomTextField
          label="Suscriptor"
          value={filters.subscriberName}
          onChange={(e) => onFilterChange('subscriberName', e.target.value)}
          disabled={disabled}
          size="medium"
          fullWidth
        />

        <CustomTextField
          label="Estado"
          select
          value={filters.status}
          onChange={(e) => onFilterChange('status', e.target.value)}
          disabled={disabled}
          size="medium"
          fullWidth
        >
          {STATUS_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </CustomTextField>

        <CustomButton
          variant="base"
          onClick={onSearch}
          disabled={disabled}
          sx={{ minWidth: { xs: '100%', md: '200px' } }}
        >
          Buscar
        </CustomButton>

        <CustomButton
          variant="base"
          onClick={onReset}
          disabled={disabled}
          sx={{ minWidth: { xs: '100%', md: '300px' } }}
        >
          Limpiar filtros
        </CustomButton>
      </Stack>
    </Paper>
  );
};

export default FiltersBar;
